export const projects = [
    {
        name: "Catan Replica",
        description: "Ongoing project to replicate the board game Catan, with Q learning AI",
        img: "/project-imgs/catan.jpg",
        tech: "React, Node, Express, MongoDB, Pytorch",
        githubLink: "https://github.com/RyanLim-RL/catan_PERN"
    },
    {
        name: "Fun Mind Games",
        description: "Games to have fun with (wordle, minesweeper, snake)",
        img: "/project-imgs/minesweeper.jpg",
        tech: "Python, Pygame",
        githubLink: "https://github.com/RyanLim-RL/Minor_project_dump"
    },
    {
        name: "Simple AirBnB Replica",
        description: "simple mimic of an app(AirBnb) to find holiday homes",
        img: "/project-imgs/bnb-replica.jpg",
        tech: "Java, Java GUI, Git",
        githubLink: "https://github.com"
    },
    {
        name: "Number Classifier",
        description: "Simple MNIST number classifier with 95% accuracy",
        img: "/project-imgs/numberClass.jpg",
        tech: "Keras",
        githubLink: "https://github.com"
    },
    {
        name: "Ticketopia",
        description: "Event Booking App made for a sudo-client in a team in 2nd Year of university",
        img: "/project-imgs/ticket.jpg",
        tech: "React, Node, Express, Postgres, Prisma, Git",
        githubLink: "https://github.com/TomHurford/TeamTeam-BookingApp"
    },
    {
        name: "Pacman AI",
        description: "Value Iteration methods to automate pacman",
        img: "/project-imgs/pacman.jpg",
        tech: "Python",
        githubLink: "https://github.com/RyanLim-RL/Pacman-AI"
    },
    {
        name: "Personal Portfolio",
        description: "What you see right now!",
        img: "/project-imgs/portfolio.jpg",
        tech: "React, Node, Express",
        githubLink: "https://github.com/RyanLim-RL/my_personal_portfolio"
    },
    {
        name: "Finance Tracker",
        description: "Scrapes bank statements for data analysis",
        img: "/project-imgs/bank-app.jpg",
        tech: "Python, Pytorch",
        githubLink: "https://github.com/RyanLim-RL/Finance_Tracker"
    },
    {
        name: "LLM Dissertation",
        description: "Topic: LLMs in the use of automated test generation",
        img: "/project-imgs/llm.jpg",
        tech: "OPENAI API",
        githubLink: "https://github.com"
    },
    {
        name: "Volley Ball App",
        description: "Ongoing project to help managage and create volleyball teams",
        img: "/project-imgs/volleyball.jpg",
        tech: "Flutter, Firebase, Git",
        githubLink: "https://github.com/A-Gully/one-of-us"
    },
    {
        name: "Catan Replica",
        description: "Ongoing project to replicate the board game Catan, with Q learning AI",
        img: "/project-imgs/catan.jpg",
        tech: "React, Node, Express, MongoDB",
        githubLink: "https://github.com/RyanLim-RL/catan_PERN"
    },
    {
        name: "Fun Mind Games",
        description: "Games to have fun with (wordle, minesweeper, snake)",
        img: "/project-imgs/minesweeper.jpg",
        tech: "Python, Pygame",
        githubLink: "https://github.com/RyanLim-RL/Minor_project_dump"
    },
    {
        name: "Simple AirBnB Replica",
        description: "Project I did in 1st Year of university",
        img: "/project-imgs/bnb-replica.jpg",
        tech: "Java, Java GUI, Git",
        githubLink: "https://github.com"
    },
    {
        name: "Number Classifier",
        description: "Simple MNIST number classifier with 95% accuracy",
        img: "/project-imgs/numberClass.jpg",
        tech: "Keras",
        githubLink: "https://github.com"
    },
    {
        name: "Ticketopia",
        description: "Event Booking App made for a sudo-client in a team in 2nd Year of university",
        img: "/project-imgs/ticket.jpg",
        tech: "React, Node, Express, Postgres, Prisma, Git",
        githubLink: "https://github.com/TomHurford/TeamTeam-BookingApp"
    },
    {
        name: "Pacman AI",
        description: "Value Iteration methods to automate pacman",
        img: "/project-imgs/pacman.jpg",
        tech: "Python",
        githubLink: "https://github.com/RyanLim-RL/Pacman-AI"
    },
    {
        name: "Personal Portfolio",
        description: "What you see right now!",
        img: "/project-imgs/portfolio.jpg",
        tech: "React, Node, Express",
        githubLink: "https://github.com/RyanLim-RL/my_personal_portfolio"
    },
    {
        name: "Finance Tracker",
        description: "Scrapes bank statements for data analysis",
        img: "/project-imgs/bank-app.jpg",
        tech: "Python, Pytorch",
        githubLink: "https://github.com/RyanLim-RL/Finance_Tracker"
    },
    
]